import type {
  MarkSupportTicketReadRequest,
  SupportTicketUnreadCountResponse,
} from "@repo/shared/types";
import { get, post } from "./_client";

const BASE = "/internal/support-tickets";

/** How many visible tickets have a comment this user has not read — the sidebar badge. */
export function getUnreadCommentCount(): Promise<SupportTicketUnreadCountResponse> {
  return get<SupportTicketUnreadCountResponse>(`${BASE}/unread-count`);
}

/**
 * Clear the badge for one ticket, up to the newest comment we actually showed.
 * Passing that id keeps a comment that lands between loading the detail and
 * this call from being marked read unseen.
 */
export function markTicketRead(
  ticketId: string,
  readThroughCommentId?: string,
): Promise<{ success: boolean }> {
  return post<{ success: boolean }>(`${BASE}/${ticketId}/mark-read`, {
    readThroughCommentId,
  } satisfies MarkSupportTicketReadRequest);
}
